"use client";
import React, { ReactNode } from "react";
import { Modal } from "@/app/(components)/Basic/Modal";

export interface Props {
  title: string;
  children: ReactNode;
  grandChildren: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  disableClose?: boolean;
  hasCloseButton?: boolean;
}

function EntityModalBase({
  isOpen,
  onClose,
  title,
  children,
  grandChildren,
  disableClose,
  hasCloseButton,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      className="sm:w-[510px] lg:p-10"
      disableClose={disableClose}
      hasCloseButton={hasCloseButton}
    >
      <div className="flex flex-col items-center text-center">
        <h3 className="font-semibold mb-4 text-primary endemic:text-invert">
          {title}
        </h3>
        {children}
      </div>
      <div className="text-left relative">{grandChildren}</div>
    </Modal>
  );
}

export default EntityModalBase;
